
import { type } from '../constants/manageNumbersConstant'
import { DocumentListReducer } from '../models/manageNumbers.interface';

const initialState: DocumentListReducer = {
    documentListData: [],
    documentListLoading: false,
    documentListError: false,
    documentListErrorMsg: '',
}

const documentListReducer = (state: DocumentListReducer = initialState, action: any): DocumentListReducer => {

    switch (action.type) {
        case type.DOC_LIST_LOADING:
            return {
                ...state,
                documentListLoading: true,
            }
        case type.DOC_LIST_SUCCESS:
            return {
                ...state,
                documentListLoading: false,
                documentListData: action.payload.res.data,
            }
        case type.DOC_LIST_FAILED:
            return {
                ...state,
                documentListLoading: false,
                documentListError: true,
                documentListErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default documentListReducer;